export const REFRESH_SITE_STORAGE_KEY =
  process.env.NEXT_PUBLIC_SESSION_REFRESH_SITE_STORAGE_KEY ?? 'refreshSite';
